import { hooks, Report, Elements } from '@tfo/common'
import { observer } from 'mobx-react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import RootStore from '../../stores/RootStore'
import '../../index.scss'
import './ReadReport.scss'
import { IndividualViewStore } from '../../stores/IndividualViewStore'
import $http from '../../utils/$http'
import { IntlProviderWrapper } from '../../IntlProviderWrapper'
import Loader from '../common/loader/Loader'
import { ReportStore } from '../../stores/ReportStore'

const { Heading4, Paragraph } = Elements

export interface ReadReportProps {
	backoffice?: boolean
}

export const InfoSection = ({
	i18n,
}: {
	i18n: Function
}) => (
	<div className={'ReadReportContent__Section'} id={'Info'}>
		<Heading4>{i18n('readreport.info.heading')}</Heading4>
		<Paragraph className={'ReadReportContent__Space--medium'}>
			{i18n('readreport.info.preamble')}
		</Paragraph>
	</div>
)

const ReadReportWithNewLocale = observer(({reportStore} : {reportStore: ReportStore}) => {
	const intl = useIntl()
	const i18n = (id: string) => intl.formatMessage({ id })
	const formatDate = date => (date ? intl.formatDate(date) : '')
	const formatTime = date => (date ? intl.formatTime(date) : '')

	const getFilesMetaData = async () => reportStore.order.fileMetaData
	const getFile = (fileId) => $http.get<any>(`order/${reportStore.order.id}/file/${fileId}`, 'blob')

	return (<Report.Report key={reportStore.order.id}
				{...{ i18n, formatDate, formatTime, reportStore: (reportStore as any), InfoSection, getFilesMetaData, getFile }}
			/>)
})

//The new IntlProvider needs to encapsulate the next useIntl() statement for it reflect any locale changes.
const ReadReport = observer(() => {
	// Need to be use the store here and push it downwards,
	// otherwise the store is initialized twice somehow and it breaks.
	const { reportStore } = hooks.useReportStore2<RootStore>() as IndividualViewStore
	return reportStore?.order
		? (
			<IntlProviderWrapper languageSettings={{language: reportStore.language}} >
				<ReadReportWithNewLocale reportStore={reportStore} />
			</IntlProviderWrapper>)
		: (<Loader />)
})

export default ReadReport
